import { clsx } from 'clsx';
import { Tooltip } from '../../../tooltip/Tooltip';
import { Icon } from '../../../icon/Icon';
import { kebabUnderscoreToDisplayString } from '../../../shared/utils/string/formatter';

export function NonConfigurableRowStatus({
  className,
  status,
  reason,
  hideTooltip
}: {
  className?: string;
  status: string;
  reason?: string;
  hideTooltip?: boolean;
}) {
  return (
    <Tooltip dataId='' title={reason} disabled={hideTooltip || !reason}>
      <div className={clsx('center-flex-row text-secondary', className)}>
        <Icon dataId='' name='warning' className='mr-1' size={1} />

        {kebabUnderscoreToDisplayString(status)}
      </div>
    </Tooltip>
  );
}
